<template>
  <div class="popup" v-if="is_sign" @click="escFun">
    <div class="popup_div cover_img" :style="leftBg" @click.stop="">
      <i class="esc" @click="escFun"><img src="@/assets/img/shutDown.png" alt=""></i>
      <div class="integral flex_center">
        <i><img src="@/assets/img/integral.png" alt=""></i>
        <span>{{score}}</span>
        /积分
      </div>

      <div class="sign_title">已累计签到</div>
      <div class="flex_center number_div">
        <span class="number flex_center" v-for="liem,index in number" :key="index">{{liem}}</span>
        <span class="tag">次</span>
      </div>
      <div class="prompt">签到获得更多积分</div>
      <button class="sign_button flex_center" @click="getSign(1)" v-if="isSign">点我签到</button>
      <div class="prompt prompt_num" v-else>完成签到！获得+2积分</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "popup",
  data() {
    return {
      number: "000", //签到天数
      leftBg: {
        background:
          "#fff url(" + require("@/assets/img/sign_bg.png") + ") no-repeat",
      },

      score: 0, //积分
      count: 0, //签到数量
      isSign: true, //1已签0未签
    };
  },
  props: {
    is_sign: {
      type: Boolean,
      default: false,
    },
    live_id: {
      type: String,
    },
  },
  watch: {
    is_sign: function (eve) {
      let that = this;
      if (eve == true) {
        this.getSign(2);
        this.$nextTick(() => {
          that.mobileFun();
        });
      }
    },
  },
  methods: {
    mobileFun() {
      if (this._isMobile()) {
        $(".popup").addClass("mobile");
      }
    },
    countFun() {
      //计算签到数量
      if (this.count < 10) {
        this.number = "00" + this.count;
      } else if (this.count >= 10 && this.count < 100) {
        this.number = "0" + this.count;
      } else {
        this.number = this.count;
      }
    },
    getSign(type) {
      //获取签到信息
      let that = this;
      this.$post("sign", {
        live_id: this.live_id,
        member_id: this.USER().id,
        type: type,
      }).then((eve) => {
        if (type == 2) {
          that.score = eve.data.score;
          that.isSign = eve.data.is_sign == 1 ? false : true;
          that.count = eve.data.count;
          that.countFun();
        } else {
          layer.open({
            content: "签到成功!",
            time: true,
            skin: "msg",
          });
          that.getSign(2);
        }
      });
    },
    escFun() {
      //关闭签到
      this.$emit("signFun");
    },
  },
  mounted() {
    this.mobileFun();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}
.popup .popup_div {
  position: absolute;
  top: 50%;
  min-width: 477px;
  max-width: 600px;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.16);
  padding: 40px 56px;
}
.popup .popup_div .esc {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  width: 26px;
  height: 26px;
  color: #666;
}
.integral {
  position: absolute;
  left: 16px;
  top: 16px;
  font-size: 20px;
  align-items: flex-end;
}
.integral > i {
  width: 30px;
  margin-right: 6px;
}
.integral > span {
  color: #fcba07;
}
.sign_title {
  font-size: 25px;
  color: #1a1a1a;
  text-align: center;
}
.number_div {
  margin: 20px auto;
  align-items: flex-end;
}
.number_div .tag {
  font-size: 22px;
  color: #333;
  margin-left: 10px;
}
.number_div .number {
  width: 54px;
  height: 88px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 3px 0 7px rgba(0, 0, 0, 0.35);
  margin: 0 10px;
  font-size: 48px;
  color: #f04c5a;
}
.popup_div .prompt {
  font-size: 22px;
  margin: 10px auto;
  text-align: center;
}
.popup_div .sign_button {
  width: 240px;
  height: 55px;
  border-radius: 28px;
  margin: 20px auto 0 auto;
  font-size: 28px;
  color: #fff;
  background-image: linear-gradient(90deg, #f54050, #ec3141);
  border: 0;
}
.popup_div .prompt.prompt_num {
  color: #fcba07;
  font-size: 24px;
}

/* 手机端样式哦 */
.popup.mobile .popup_div {
  max-width: 80%;
  min-width: 60%;
  width: 70%;
  border-radius: 1rem;
  padding: 3rem 0;
}
.popup.mobile .popup_div .integral {
  font-size: 1.2rem;
  align-items: flex-end;
  color: 666;
  top: 1rem;
  left: 1rem;
}
.popup.mobile .popup_div .integral > i {
  width: 1.6rem;
}
.popup.mobile .popup_div .esc {
  width: 1.8rem;
  right: 1rem;
  top: 1rem;
  height: auto;
}
.popup.mobile .popup_div .sign_title {
  font-size: 1.4rem;
  color: #1a1a1a;
}
.popup.mobile .popup_div .number_div .number {
  width: 2.7rem;
  height: 4.4rem;
  border-radius: 0.3rem;
  font-size: 2.4rem;
  color: #f04c5a;
  margin: 0 0.3rem;
}
.popup.mobile .popup_div .number_div .tag {
  font-size: 1.1rem;
  color: #333;
}
.popup.mobile .popup_div .prompt {
  font-size: 1.2rem;
  color: #333;
}
.popup.mobile .popup_div .sign_button {
  width: 70%;
  height: 4rem;
  font-size: 2rem;
}
.popup.mobile .popup_div .prompt_num.prompt {
  color: #fcba07;
  font-size: 1.4rem;
}
</style>


// WEBPACK FOOTER //
// src/components/assembly/SignIn.vue